import React, { useState, useEffect } from "react";
import Blink from "./Blink.js";

export default function Title(props) {
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  const [isBlinkVisible, setIsBlinkVisible] = useState(false);
  const currentSlide = props.currentSlide;

  useEffect(() => {
    const titleTimer = setTimeout(() => {
      setIsTitleVisible(true);
      const blinkTimer = setTimeout(() => {
        setIsBlinkVisible(true);
      }, 1000); // 1 seconds delay for blink after title

      // Cleanup blink timer when component unmounts
      return () => clearTimeout(blinkTimer);
    }, 3000); // 3 seconds delay for title

    // Cleanup title timer when component unmounts
    return () => clearTimeout(titleTimer);
  }, []);

  if (!currentSlide.title) {
    return null;
  }
  
  return (
    <>
    <div
      style={{
          position: "fixed",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: "1500",
          flexDirection: "column",
          zindex: 100,
          opacity: isTitleVisible ? "1" : "0",
          pointerEvents: "none",
          width: "100vw",
          height: "100vh",
          transition: "opacity 2s",
          //margin: props.isMobile ? "0vw 0vw" : "4vh 0vw",

      }}
    >
       {isTitleVisible && currentSlide.title.split("\r\n\r\n").map((p, i) => (
        <div
          key={i}
          style={{
            color: "white",
            fontWeight: i === 0 ? "800" : "normal",
            fontSize: props.isMobile 
              ? i === 0 
                ? "35px" 
                : i === 1 
                  ? "20px" 
                  : "15px"
              : i === 0 
                ? "45px" 
                : i === 1 
                  ? "25px" 
                  : "20px",
            fontStyle: i === 1 ? "italic" : "normal",
            textAlign: "center",
            padding: props.isMobile? "1vh 5vw":"1vh 0vw"
          }}
        >
          {p}
        </div> 
      ))}
  </div>

  {isBlinkVisible && (
    <div
        style={{
          position: "fixed",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          zIndex: "1500",
          bottom: "10%",  // Adjust as needed for position
          left: "50%",
          transform: "translateX(-50%)",
          opacity: isBlinkVisible ? "0.5" : "0",
          transition: "opacity 2s",
        }}
        >

      <Blink>
        <div
          style={{
            borderLeft: "1px white solid",
            height: props.isMobile? "15vw":"5vw",
            display: "inline-block",
          }}
        />
      </Blink>
      
      <Blink>
        <div
          style={{
            color: "white",
            fontSize: "15px",
          }}
        >
          Scroll
        </div>
        </Blink>
    </div>
  )}
  </>
  )}